import { Link } from 'react-router-dom';

export default function Article3() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4 cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Blog
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mt-2 leading-tight">How TV Placement Affects Comfort and Viewing Experience</h1>
          <time className="text-sm text-gray-500 mt-4 block">May 8, 2024</time>
        </div>
      </header>

      {/* Article Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Featured Image */}
          <div className="w-full h-96 mb-10 rounded-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/4b06b4f7afc1d73771799b1def6db88f.jpg"
              alt="Proper TV placement for comfortable viewing"
              title="Proper TV placement for comfortable viewing"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <p className="text-lg leading-relaxed text-gray-800">
            TV placement has a significant impact on viewing comfort and long-term enjoyment. Screens positioned too high or at awkward angles can cause neck strain and reduce overall viewing quality.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Proper placement considers seated eye level, viewing distance, and room layout. Aligning the centre of the screen with natural eye height helps maintain a comfortable posture during extended viewing sessions. Window placement and lighting are also important to minimise glare.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Wall mounting allows greater flexibility in achieving ideal placement compared to furniture-based setups. This flexibility makes it easier to tailor the viewing experience to the specific room and household.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Examples of thoughtfully planned TV placement and mounting layouts are available at: <a href="https://tv-wall-mounting-melbourne.bitbucket.io/tv-wall-mounting-sound-design.html" className="text-gray-900 underline hover:text-gray-700 cursor-pointer break-all">https://tv-wall-mounting-melbourne.bitbucket.io/tv-wall-mounting-sound-design.html</a>
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            For general information about Australian public services and government resources, the <a href="https://www.australia.gov.au/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-700 cursor-pointer">Australia.gov.au</a> portal serves as a central reference.
          </p>

          {/* Embedded Reference */}
          <div className="my-10 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://sites.google.com/view/tvwallmountingmelbourne/home"
              className="w-full h-96"
              title="Embedded site reference"
            ></iframe>
          </div>
        </article>

        {/* Navigation */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <Link 
            to="/blog"
            className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to all articles
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Wall Setup &amp; Home Installations. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 hover:text-gray-900 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
